/**
 * Bullet-Points-Anzeige als nummerierte Zeilen (Variant D).
 *
 * Read-only Darstellung der Bullets eines Channels (Bearbeitung/Save laufen über
 * den separaten Custom-Field-Pfad, nicht über den generischen Text-Save).
 */

import { useTranslation } from 'react-i18next'
import { readBullets } from './contentBlockLang'
import type { ContentBlock } from '@/types/content-blocks'

interface Props {
  block: ContentBlock
  lang: string
}

export function BulletsFieldEditor({ block, lang }: Props) {
  const { t } = useTranslation()
  const bullets = readBullets(block.current_version?.content, lang)

  if (bullets.length === 0) {
    return <p className="text-sm text-neutral-500 dark:text-neutral-400 italic">{t('content.noContent')}</p>
  }

  return (
    <ul className="content-bullets flex flex-col gap-1.5">
      {bullets.map((b, i) => (
        <li key={i} className="flex items-center gap-2">
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-primary-500 text-white text-xs font-bold">{i + 1}</span>
          <span className="text-sm text-neutral-800 dark:text-neutral-200">{b}</span>
        </li>
      ))}
    </ul>
  )
}
